// extracted by mini-css-extract-plugin
export default {"blankIcon":"App_blankIcon__cvN4p","App":"App_App__B2Ebb","App-header":"App_App-header__PyRwd","toolbar":"App_toolbar__Xae4R","board":"App_board__uWkHG"};